import React, { useCallback, useEffect, useState } from 'react'

import { PrazoEncerrado } from 'components/Svg'
import { Card, CollapseSearch, Row, Button, Image, Span } from 'components'
import { SuccessModal } from 'components/SuccessModal/SuccessModal'
import { useLoading, useAuth, useModal } from 'hooks'
import useToggle from 'hooks/useToggle'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import { CreParamsServices } from 'services/NGT/CreParams'
import { MovDocumentItemServices } from 'services/Supplier/MovDocumentItem'
import {
  Anexo,
  CollpaseContrato,
  MonthlyDocumentsServices
} from 'services/Supplier/ThirdPartyAdministration'
import { COLORS, SPACING, FORMAT } from 'utils'
import { convertBase64 } from 'utils/functions'

import { SearchMonthlyDocumentation } from './components'
import { TableMonthlyDocumentation } from './components/TableMonthlyDocumentation/TableMonthlyDocumentation'

export const MonthlyDocumentation: React.FC = () => {
  const {
    user: { IdUsuario, PerfilUsuarioId }
  } = useAuth()
  const { msgErro, setLoading, setMsgErro } = useLoading()
  const { showModal } = useModal()

  const { control, watch } = useForm()
  const searchGlobal = watch('searchGlobal')

  const [listContracts, setListContracts] = useState<
    CollpaseContrato[] | undefined
  >()
  const [dayExpiration, setDayExpiration] = useState<string>('')
  const [competenciaAtual, setCompetenciaAtual] = useState<string>()
  const [openSuccess, setOpenSuccess] = useState<boolean>(false)
  const [isError, toggleErrorModal] = useToggle()

  const getData = async () => {
    setLoading('loading')
    if (PerfilUsuarioId === 6) {
      MonthlyDocumentsServices()
        .get(0, IdUsuario)
        .then((response) => {
          if (response.status === 200) {
            setListContracts(response.data as CollpaseContrato[])
            setCompetenciaAtual(response?.data[0]?.anoMesCompetencia)
          }

          setLoading('idle')
        })
        .catch(() => {
          // setLoading("error")
          // toggleErrorModal()
          // setMsgErro('Erro obter dados')
          setLoading('idle')
          showModal({
            hideButtonCancel: true,
            message: 'Erro obter dados',
            txtButtonConfirm: 'Fechar',
            type: 'error'
          })
        })
      return
    }

    MonthlyDocumentsServices()
      .get(IdUsuario)
      .then((response) => {
        if (response.status === 200) {
          setListContracts(response.data as CollpaseContrato[])
          setCompetenciaAtual(response?.data[0]?.anoMesCompetencia)
        }

        setLoading('idle')
      })
      .catch(() => {
        // setLoading("error")
        // toggleErrorModal()
        // setMsgErro('Erro obter dados')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Erro obter dados',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  interface addFileToAttachmentProps {
    file: File
    idMovDocumentoForAdd: number
  }

  const addFileToAttachment = async ({
    file,
    idMovDocumentoForAdd
  }: addFileToAttachmentProps) => {
    setLoading('loading')

    try {
      const fileBase64: any = await convertBase64(file)

      setListContracts((prevState) =>
        prevState?.map((contrato) => {
          return {
            ...contrato,
            anexos: contrato.anexos?.map((anexo) => ({
              ...anexo,
              ...(anexo.idMovDocumento === idMovDocumentoForAdd && {
                base64: fileBase64,
                filename: file.name
              })
            }))
          }
        })
      )

      setLoading('idle')
    } catch (error) {
      // setLoading("error")
      setLoading('idle')
      toggleErrorModal()
      setMsgErro('Não foi possível fazer o upload do arquivo')
    }
  }

  const removeFileFromAttachment = (idMovDocumentoForRemove: number): void => {
    setLoading('loading')

    try {
      setListContracts((prevState) =>
        prevState.map((contrato) => {
          return {
            ...contrato,
            anexos: contrato.anexos?.map(({ base64, filename, ...anexo }) => {
              if (base64) {
                if (anexo.idMovDocumento === idMovDocumentoForRemove) {
                  return {
                    ...anexo
                  }
                }

                return {
                  ...anexo,
                  base64,
                  filename
                }
              }

              return anexo
            })
          }
        })
      )

      setLoading('idle')
    } catch (error) {
      // setLoading("error")
      toggleErrorModal()
      setMsgErro('Não foi possível deletar o anexo, tente novamente')
    }
  }

  const handleJustify = (txt: string, context: Anexo) => {
    setListContracts((prevState) =>
      prevState?.map((contract) => ({
        ...contract,
        anexos: contract?.anexos?.map((anexo) =>
          anexo.idMovDocumento === context.idMovDocumento
            ? {
              ...anexo,
              txJustificativa: txt
            }
            : anexo
        )
      }))
    )
  }

  function ajustarData(data: Date) {
    const novaData = new Date(data);
    novaData.setHours(novaData.getHours() - 3);
    return novaData;
  }

  const handleSendAttachments = (contractID: number) => {
    setLoading('loading')

    const MAX_FILE_SIZE = 120 * 1024 * 1024; 


    const newAttchmentFiles = listContracts
      .filter((contrato) => contrato.idContrato === contractID)
      ?.map((contrato) =>
        contrato.anexos
          .filter((anexo) => anexo.filename)
          ?.map((anexo) => ({
            cdDocto: contrato.cdDocumento.trim(),
            competencia: contrato.competencia,
            contratoId: contrato.idContrato,
            fornecedor: contrato.nmFornecedor,
            ...anexo
          }))
      )
      .flat()
      ?.map((anexo) => ({
        cdDocto: anexo.cdDocto,
        cdStatus: anexo.cdStatus,
        competencia: parseInt(moment(anexo.competencia).format('YYYYMM')),
        contratoId: anexo.contratoId,
        dtAnexado: ajustarData(new Date()).toISOString(),
        file: anexo.base64,
        fornecedor: anexo.fornecedor,
        gedExternalId: String(anexo.cdGedExternalId),
        idMovDocumentoItem: anexo.idMovDocumento,
        justificativa: anexo.txJustificativa || '',
        movDocumentoId: anexo.idMovDocumento,
        tipoPendenciaId: anexo.tipoPendenciaId,
        txFilename: anexo.filename,
        txVersao: ''
      }))

    const dontHaveDocument = newAttchmentFiles.map(anexo => anexo.cdDocto).includes('')

    if (dontHaveDocument) {
      setLoading('idle')
      showModal({
        type: 'alert',
        titleModal: 'Atenção!',
        message: 'Fornecedor não possui documento de registro cadastrado, favor contatar analista CSN.',
        txtButtonConfirm: 'OK',
        hideButtonCancel: true,
      })

      return
    }

    let fileSizeBiggerThanMax=false;
      newAttchmentFiles.forEach(x=>{
        if(base64Size(x.file)>MAX_FILE_SIZE){
          showModal({
            hideButtonCancel: true,
            message: 'Você está tentando anexar um arquivo com tamanho maior do que o permitido. Limite máximo: 120MB',
            txtButtonConfirm: 'OK',
            type: 'error',
          });
          fileSizeBiggerThanMax=true;
          setLoading('idle');

          return;
        }
      })
        if(fileSizeBiggerThanMax)return;

    MovDocumentItemServices()
      .CreateMovDocumentItemsGED(newAttchmentFiles)
      .then((response) => {
        if (response.status === 200) {
          setOpenSuccess(true)
        }

        setLoading('idle')
      })
      .catch(() => {
        // setLoading("error")
        // toggleErrorModal()
        // setMsgErro('Não foi possível enviar os arquivos')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível enviar os arquivos',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const base64Size = (base64String: string) => {
    const stringLength = base64String.length;
    const sizeInBytes = (stringLength * 3) / 4 - (base64String.endsWith('==') ? 2 : base64String.endsWith('=') ? 1 : 0);
    return sizeInBytes;
  }

  useEffect(() => {
    getData()
  }, [])

  const expirationTime = () => {
    setLoading('loading')

    CreParamsServices()
      .getParametrizacaoCRE()
      .then((response) => {
        if (response.status === 200) {
          const [CREInfo] = response.data

          setDayExpiration(CREInfo.dsDiaFimFechamentoAnexoDoc)
        }
      })
      .catch(() => {
        // setLoading("error")
        // toggleErrorModal()
        // setMsgErro('Não foi possível obter o prazo de vencimento')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter o documento',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  useEffect(() => {
    if (parseInt(dayExpiration) - new Date().getDate() < 0) {
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [dayExpiration])

  useEffect(() => {
    expirationTime()
  }, [])

  const filterTable = () => {
    if (!searchGlobal) {
      return listContracts
    }

    return listContracts.filter(
      (contrato) =>
        contrato.nmFornecedor
          .toLowerCase()
          .includes(searchGlobal.toLowerCase()) ||
        contrato.cdContrato.toLowerCase().includes(searchGlobal.toLowerCase())
    )
  }

  return (
    <>
      {dayExpiration && listContracts && (
        <>
          <Card
            marginLeft={SPACING.spacing100}
            marginRight={SPACING.spacing15}
            marginBottom={SPACING.spacing100}
            padding={SPACING.spacing20}
            boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
            backgroundColor={COLORS.white}
            borderRadius={`0px 10px 0px 0px`}
            style={{
              left: '15px',
              paddingBottom: '5rem',
              position: 'absolute',
              right: '15px'
            }}
          >
            <>
              {!!dayExpiration && (
                <SearchMonthlyDocumentation
                  control={control}
                  dayExpiration={dayExpiration}
                  listContracts={listContracts}
                  competenciaAtual={competenciaAtual}
                />
              )}
              {listContracts?.length === 0 && (
                <Row
                  alignItems="center"
                  justifyContent="center"
                  marginBottom={SPACING.spacing50}
                  marginTop={SPACING.spacing20}
                >
                  <Span
                    text="Não há documentos pendentes na competência atual"
                    fontSize="1rem"
                    fontWeight="bold"
                    color={COLORS.info}
                  />
                </Row>
              )}
              {filterTable()?.map((row, index) => (
                <CollapseSearch
                  key={`${index}-collpase`}
                  data={{
                    code: row?.cdContrato,
                    dataFim: FORMAT.formatDDMMYYYY(row?.dtVigenciaFim),
                    dataIni: FORMAT.formatDDMMYYYY(row?.dtVigenciaInicio),
                    empresa: row?.nmFornecedor,
                    titleCollapse: row?.txObjetoContrato
                  }}
                  hideButton
                >
                  <TableMonthlyDocumentation
                    tableData={row?.anexos}
                    handleJustify={handleJustify}
                    handleDeleteDocument={removeFileFromAttachment}
                    handleUploadFile={addFileToAttachment}
                  />
                  <Row
                    justifyContent="flex-end"
                    alignItems="center"
                    marginTop={SPACING.spacing20}
                  >
                    <Button
                      onClick={() => handleSendAttachments(row.idContrato)}
                      disabled={!row?.anexos || row?.anexos?.length === 0}
                      text="ENVIAR"
                    />
                  </Row>
                </CollapseSearch>
              ))}
            </>
          </Card>

          {parseInt(dayExpiration) - new Date().getDate() < 0 && (
            <div style={{ position: 'relative' }}>
              <PrazoEncerrado width="90%" height="50vh" />
            </div>
          )}

          <SuccessModal
            open={openSuccess}
            type="sucess"
            message="Os anexos foram enviados para a análise"
            hideButtonCancel
            txtButtonConfirm="OK"
            handleConfirm={() => {
              setOpenSuccess(false)
              getData()
            }}
          />
          <SuccessModal
            open={isError}
            type="error"
            message={msgErro}
            hideButtonCancel
            txtButtonConfirm="OK"
            handleConfirm={() => toggleErrorModal()}
          />
        </>
      )}
    </>
  )
}
